import * as common from '../common/common';
export const DEFAULT_GOTIFICATIONS_SUBSCRIBE_TTLApi = 3600;
export var ResourceTypeApi;
(function (ResourceTypeApi) {
    ResourceTypeApi["PROJECT_OWNER"] = "project_owner";
    ResourceTypeApi["PROJECT"] = "project";
    ResourceTypeApi["BID"] = "bid";
    ResourceTypeApi["THREAD"] = "thread";
    ResourceTypeApi["TEST_RESOURCE"] = "test_resource";
    ResourceTypeApi["GROUP"] = "group";
})(ResourceTypeApi || (ResourceTypeApi = {}));
export const ResourceServiceMapApi = {
    [ResourceTypeApi.PROJECT_OWNER]: common.ThriftPortsApi.PROJECT,
    [ResourceTypeApi.PROJECT]: common.ThriftPortsApi.PROJECT,
    [ResourceTypeApi.BID]: common.ThriftPortsApi.PROJECT,
    [ResourceTypeApi.THREAD]: common.ThriftPortsApi.MESSAGES,
    [ResourceTypeApi.TEST_RESOURCE]: common.ThriftPortsApi.PROJECT,
    [ResourceTypeApi.GROUP]: common.ThriftPortsApi.USER,
};
